export default function() {
  const sortOptionsSelect = document.querySelector(
    '[data-collection-sort-options]'
  );

  if (!sortOptionsSelect) {
    return false;
  }

  sortOptionsSelect.addEventListener('change', () => {
    const { search } = window.location;

    const queryParams = new URLSearchParams(search);

    queryParams.set('sort_by', sortOptionsSelect.value);

    window.location.search = queryParams.toString();
  });
}
